import React from "react";

const Consultation = () => {
  return (
    <>
      <section id="consultation_area" className="section_padding_bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="consultation_area_text">
                <h2>Need Expert Guidance?</h2>
                <p>
                  Connect with our travel specialists for a personalized
                  consultation. Whether you're planning a luxury vacation,
                  corporate travel, or special event, our team is ready to
                  create your ideal travel experience. Let us transform your
                  travel dreams into reality.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Consultation;
